import { memo } from 'react';
import { Colors } from '@mercator-gcp/grout';
import { DrawingManager } from '@react-google-maps/api';
import {
  useHasPlacedFirstPolygonDrawingPoint,
  useIsPolygonDrawingEnabled,
  useSelectedPolygonBoundsOnMap,
} from 'state/map';
import { Z_INDEX_DICT } from 'utils/constants/zIndex';
import { getBoundingBoxesFromPolygon } from 'utils/polygons';

interface LatLng {
  lat: number;
  lng: number;
}

const PolygonDrawing = () => {
  const [, setSelectedPolygonBoundsOnMap] = useSelectedPolygonBoundsOnMap();
  const [, setIsPolygonDrawingEnabled] = useIsPolygonDrawingEnabled();
  const [, setHasPlacedFirstPolygonDrawingPoint] = useHasPlacedFirstPolygonDrawingPoint();

  const handlePolygonComplete = (polygon: google.maps.Polygon) => {
    setIsPolygonDrawingEnabled(false);
    const path: LatLng[] = polygon
      .getPath()
      .getArray()
      .map((latLng: google.maps.LatLng) => ({
        lat: latLng.lat(),
        lng: latLng.lng(),
      }));

    const boundingBoxes = getBoundingBoxesFromPolygon(path);
    setSelectedPolygonBoundsOnMap(boundingBoxes);
  };

  const onOverlayComplete = (e: google.maps.drawing.OverlayCompleteEvent) => {
    // Remove the drawn shape from the map after completion
    if (e.type === google.maps.drawing.OverlayType.POLYGON) {
      e.overlay.setMap(null);
    }
  };

  const onLoad = () => {
    setHasPlacedFirstPolygonDrawingPoint(false);
  };

  return (
    <DrawingManager
      options={{
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        polygonOptions: {
          fillColor: 'none',
          fillOpacity: 0,
          strokeColor: Colors.Tangerine900,
          strokeWeight: 4,
          zIndex: Number(Z_INDEX_DICT.DRAWN_POLYGON),
          editable: true,
          draggable: false,
          clickable: false,
        },
      }}
      onPolygonComplete={handlePolygonComplete}
      onOverlayComplete={onOverlayComplete}
      onLoad={onLoad}
    />
  );
};

export default memo(PolygonDrawing);
